import React from 'react';

export const About = () => (
  <div className='card mt-5'>
    <div className='card-header'>Info</div>
    <div className='card-body'>
      <blockquote className='blockquote mb-0'>
        <p>My awesome todo-list version 1.0.0.0710.</p>
        <footer className='blockquote-footer'>
          Sincerely Yours <cite title='Source Title'>Stanislav</cite>
        </footer>
      </blockquote>
    </div>
  </div>
);
